import { CPUtils } from "@/scripts/Utils";
import Global from "@/scripts/Global";
import UserApi from "@/scripts/api/user.api";
import router from "@/router";
import VueSignals from "@/scripts/VueSignals";

export default {
    name: 'Register',
    data (){
        return {
          error_message: '',
          hasError: false,
          loading: false,
          accept_agb: false,
          accept_data: false,
          user: {
              email: '',
              password: '',
              username: '',
              companyName: '',
              firstname: '',
              lastname: ''
          },        
        }
      },      
  mounted(){        
    Global.removeAllCookiesExcept(['login_token', 'login_email', 'rememberPW'], true)           
  },
  methods: {
    GetPortalURL(){
      return Global.GetPortalURL()
    },
    register(){    
      this.Validate()      
      if(!this.hasError){
        UserApi.Register(this.user.email, this.user.username,
          this.user.password, this.user.firstname, this.user.lastname, this.user.companyName).then(res => {
            if(res.data.result){
              Global.setSessionID(res.data.session_id)      
              Global.globalValue(VueSignals.AUTHENTICATED, true)
              Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
              Global.globalValue(VueSignals.SESSION_ID, res.data.session_id)
              Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel.channel_id)

            }else {
              if(res.data.reason == "user_already_exists"){
                router.push({path: '/confirmpassword/' , query: {e: this.user.email}})
              }

              if(res.data.reason == "restricted_domain"){
                this.hasError = true
                this.error_message = "Registration is not allowed, Please contact the administrator of your organisation"                  
              }
            }
          })
      }
    },
    Validate(){
      if(!CPUtils.ValidateUsername(this.user.username) || this.user.username == ""){
        this.hasError = true
        this.error_message = "Please choose username, Username can't contain Special charachters like @  / \\ . $ or space"          
      }        
      
      else if(!CPUtils.ValidatePassword(this.user.password)){
        this.hasError = true
        this.error_message = "Password at least has 8 charachters, 1 Capital charachter, 1 small charachter and symbol charachter"
      }

      else  if(this.user.email.length == 0){
        this.hasError = true
        this.error_message = "Please enter an email"          
      }
          

      else  if(!this.accept_agb && !this.accept_data){
        this.hasError = true
        this.error_message = "Please confirm the privacy statement, terms and conditions"          
      } else {
        this.hasError = false
        this.error_message = ""          
      } 

    },
  }
}
